import {exhaustive} from '@freckle/exhaustive'
import type {WordStudyQuestionType} from '@freckle/educator-entities/ts/ela/word-study/logic/word-study-question-types'
import {curriculaClient, extractData} from '@freckle/educator-entities/ts/openapi-clients'
import {parseWordStudyInputQuestion} from './../models/word-study-input-question'
import {parseWordStudyMultipleChoiceQuestion} from './../models/word-study-multiple-choice-question'
import type {WordStudyQuestion} from './../models/word-study-question'
import {parseWordStudySortingQuestion} from './../models/word-study-sorting-question'

export async function fetchWordStudyQuestion(
  wordStudyQuestionsInfoId: string
): Promise<WordStudyQuestion> {
  return await curriculaClient
    .GET('/ela/word-study/questions/{uuid}.json', {
      params: {
        path: {
          uuid: wordStudyQuestionsInfoId
        }
      }
    })
    .then(extractData)
    .then(parseWordStudyQuestion)
}

export function parseWordStudyQuestion(response: unknown): WordStudyQuestion {
  const type = identifyWordStudyQuestionType(response)
  switch (type) {
    case 'input':
      return {tag: 'input' as const, content: parseWordStudyInputQuestion(response)}
    case 'multiple_choice':
      return {
        tag: 'multiple_choice' as const,
        content: parseWordStudyMultipleChoiceQuestion(response)
      }
    case 'sorting':
      return {tag: 'sorting' as const, content: parseWordStudySortingQuestion(response)}
    default:
      return exhaustive(type)
  }
}

export function identifyWordStudyQuestionType(response: unknown): WordStudyQuestionType {
  if (response === null || typeof response !== 'object')
    throw new Error('Invalid response: identifyWordStudyQuestionType')
  if ('bucketFieldNames' in response) return 'sorting'
  if ('answers' in response) return 'multiple_choice'
  return 'input'
}
